export const trackEvent = (action, category, extra = {}) => {
  if (!globalThis.gtag) {
    console.warn("Google Analytics is not initialized.");
    return;
  }

  globalThis.gtag("event", action, {
    event_category: category,
    ...extra,
  });
};

// Send custom metrics to Google Analytics
export const trackCustomMetric = (metricName, value, extra = {}) => {
  if (!globalThis.gtag) {
    console.warn("Google Analytics is not initialized.");
    return;
  }

  globalThis.gtag("event", "custom_metric", {
    event_category: "system_metrics",
    metric_name: metricName,
    metric_value: value,
    ...extra,
  });
};

// Track user count specifically
export const trackUserCount = (realmName, userCount, timestamp = null) => {
  if (!globalThis.gtag) {
    console.warn("Google Analytics is not initialized.");
    return;
  }

  const eventData = {
    event_category: "keycloak_metrics",
    realm_name: realmName,
    user_count: userCount,
    timestamp: timestamp || new Date().toISOString(),
  };

  // Track as custom event
  globalThis.gtag("event", "user_count_update", eventData);

  // Also send as measurement for numerical analysis
  globalThis.gtag("event", "user_metrics", {
    event_category: "system_analytics",
    event_label: `${realmName}_realm`,
    value: userCount,
  });

  console.log(
    `Sent user count to Google Analytics: ${realmName} = ${userCount} users`,
  );
};

// Track user growth/changes
export const trackUserGrowth = (realmName, previousCount, currentCount) => {
  if (!globalThis.gtag) {
    console.warn("Google Analytics is not initialized.");
    return;
  }

  const growth = currentCount - previousCount;
  const growthPercentage =
    previousCount > 0 ? ((growth / previousCount) * 100).toFixed(2) : 0;

  globalThis.gtag("event", "user_growth", {
    event_category: "keycloak_analytics",
    realm_name: realmName,
    previous_count: previousCount,
    current_count: currentCount,
    growth_amount: growth,
    growth_percentage: parseFloat(growthPercentage),
    event_label: growth >= 0 ? "user_increase" : "user_decrease",
  });

  console.log(
    `User growth tracked: ${realmName} changed by ${growth} users (${growthPercentage}%)`,
  );
};

export const MAP_SEARCH = "map_search";
export const LOCATION_SEARCH = "location_search";
export const KEYWORD_SEARCH = "keyword_search";
export const AI_SERACH = "ai_search";
export const DATASETS = "datasets";
export const DOWNLOAD_REPORT = "download_report";
export const NAVIX_SEARCH = "Navix Search";

// New categories for Keycloak metrics
export const KEYCLOAK_METRICS = "keycloak_metrics";
export const USER_ANALYTICS = "user_analytics";
export const SYSTEM_METRICS = "system_metrics";
